import {connect} from 'react-redux';
import React, {Component} from 'react';
import Layout from '../Base/Layout';
import {Link} from 'react-router-dom';
import imgCancel from '../../static/img/cancel.jpg';
import {translate} from '../../utils/i18n'

export class CancellationPage extends Component {
    render() {
        let i18n = this.props.i18n;

        return (
            <Layout
                showPromoContent={false}
                title={translate('cancellationPage.document.title', i18n) !== undefined ? translate('cancellationPage.document.title', i18n) : ''}
            >
                <div className="clearfix container">
                    <div className="clearfix white_box add_container conv-blc">
                        <Link to="/" className="cancel">{translate('cancellationPage.back', i18n)}</Link>
                        <div className="clearfix heading">
                            <h2>
                                {translate('cancellationPage.title', i18n)}
                            </h2>
                        </div>
                        <div className="clearfix col-left">
                            <b className="text-info">
                                {translate('cancellationPage.mainText1', i18n)}
                            </b>
                            <img className="chest" src={imgCancel} alt=""/>
                        </div>
                        <div className="clearfix col-right">
					<span className="smab-tem">
						{translate('cancellationPage.mainText2', i18n)}
					</span>
                            <p className="installed"> {translate('cancellationPage.mainText3', i18n)}</p>
                            <ul className="list-wall">
                                <li>
                                    <span className="number">1</span>
                                    <div className="repel-box">
                                        <b>{translate('cancellationPage.simpleTitle', i18n)}</b>
                                        <p dangerouslySetInnerHTML={{__html: translate("cancellationPage.simpleHtmlContent", i18n)}}/>
                                    </div>
                                </li>
                                <li>
                                    <span className="number">2</span>
                                    <div className="repel-box">
                                        <b>{translate('cancellationPage.strongTitle', i18n)}</b>
                                        <p dangerouslySetInnerHTML={{__html: translate("cancellationPage.strongHtmlContent", i18n)}}/>
                                    </div>
                                </li>
                                <li>
                                    <span className="number">3</span>
                                    <div className="repel-box">
                                        <b>{translate('cancellationPage.flexibleTitle', i18n)}</b>
                                        <p dangerouslySetInnerHTML={{__html: translate("cancellationPage.flexibleHtmlContent", i18n)}}/>
                                        <i dangerouslySetInnerHTML={{__html: translate("cancellationPage.flexibleHtmlTipContent", i18n)}}
                                           className="under-text"/>
                                    </div>
                                </li>
                            </ul>
                            <p className="info-bar">
                                <i/>
                                <span
                                    dangerouslySetInnerHTML={{__html: translate("cancellationPage.warningContent", i18n)}}/>
                            </p>
                            <div className="armor-deviation">
						    <span className="number">
							<i/>
						</span>
                                <div className="repel-box"
                                     dangerouslySetInnerHTML={{__html: translate("cancellationPage.cancellationHtmlContent", i18n)}}/>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}


const mapStateToProps = state => ({
    i18n: state.languages.i18n,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CancellationPage);



// WEBPACK FOOTER //
// ./src/components/AgreementCancellation/CancellationPage.js